import Login from "../../../app/auth/login";

export const publicRoutes = [
  {
    path: "/",
    component: <Login />,
  },
];
